import { IconName } from '@/shared/ui/IconBase'

export const views = ['success', 'error', 'default'] as const

export const iconNameMap: Record<(typeof views)[number], IconName> = {
    success: 'icon-checked_outline',
    error: 'icon-cross_outline',
    default: 'icon-alert_outline',
}
